module.exports = __webpack_public_path__ + "img/IMG_6783-Edit.6bc4fd76.jpg";